export default __webpack_public_path__ + "static/media/timegrief.60d93035.jpg";